export default {
    "title": "Transport / {{client}}",
    "description": "Transport list",
    "filters": {
        "transportCode": "Transport code",
        "material": "Material",
        "status": "Status",
        "statusAll": "All"
    },
    "statuses": {
        "0": "Initial",
        "1": "In progress",
        "2": "In progress",
        "3": "In progress",
        "4": "Completed",
        "other": "Other"
    },
    "transportationTableColumns": {
        "departure_date": "Departure date",
        "planned_arrival": "Planned arrival date",
        "actual_arrival": "Arrival date",
        "transport_code": "Transport code",
        "material": "Material",
        "status": "Status",
        "location": "Location",
        "description": "Description",
    },
    "transport": "Transport",
    "materials": "materials",
    "viewLocation": "View map",
    "lastUpdate": "Last update",
    "refresh": "Refresh",
    "refreshing": "Refreshing…",
    "tracking": "Transport tracking",
    "currentStatus": "Current status",
    "inTransitDescription": "The vehicle is on its way to the destination.",
    "notStartedDescription": "The vehicle has not yet departed.",
    "arrivedDescription": "The vehicle has arrived at its destination.",
    "driver": "Driver",
    "contactPhone": "Contact phone",
    "origin": "Origin",
    "scheduleNotice": "Times are estimated and may change according to traffic conditions.",
    "plannedArrival": "Planned arrival",
    "deliveryDue": "Expected delivery",
    "actualArrival": "Arrival at customer",
    "destination": "Destination",
    "truck": "Truck",
    "shipmentSummary": "Shipment summary",
    "noCoordinates": "There are no coordinates available for this transport.",
    "close": "Close",
    "noDate": "No date",
    "nameCollection": "transports",
    "results": "results",
    "realTimeInfo": "Real-time shipping information"
}
